import { BrowserModule } from '@angular/platform-browser';
import {APP_INITIALIZER, ErrorHandler, NgModule} from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatButtonModule } from '@angular/material/button';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatCardModule} from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {
  MatDatepickerModule,
  MatFormFieldModule,
  MatMenuModule,
  MatSidenavModule,
  MatInputModule,
  MatNativeDateModule,
  MatSelectModule,
  MatRadioModule,
  MatExpansionModule,
  MatGridListModule,
  MatTableModule,
  MatDialogModule,
  MatIconModule,
  MatProgressSpinnerModule,
  MatListModule,
  MAT_DATE_LOCALE, MatAutocompleteModule, MatChipsModule
} from '@angular/material';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { DetalleCfeComponent } from './popups/detalle-cfe/detalle-cfe.component';
import {HttpClientModule} from '@angular/common/http';
import {EmisionCfeService} from './services/emision-cfe.service';
import { SuccessComponent } from './popups/success/success.component';
import { ErrorComponent } from './popups/error/error.component';
import { ProgressSpinnerComponent } from './components/progress-spinner/progress-spinner.component';
import {AuthenticationService} from './services/authentication.service';
import {KeycloakAngularModule, KeycloakService} from 'keycloak-angular';
import {initializer} from './utils/keycloak/keycloak-init';
import {MainContainerModule} from './pages/main-container/main-container.module';
import { ConfirmationComponent } from './popups/confirmation/confirmation.component';
import {NumberDirective} from './directives/number.directive';
import {GlobalErrorHandlerService} from './services/global-error-handler.service';
import {ErrorPageModule} from './pages/error-page/error-page.module';
import {PageNotFoundModule} from './pages/page-not-found/page-not-found.module';
import {ErrorPageService} from './services/error-page.service';
import {SharedModule} from './modules/shared/shared.module';
import { VersionComponent } from './popups/version/version.component';
import {HashLocationStrategy, LocationStrategy} from '@angular/common';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { DetalleTipoCodigoComponent } from './popups/detalle-cfe/detalle-tipo-codigo/detalle-tipo-codigo.component';
import { ComprobantePDFViewComponent } from './components/comprobante-pdfview/comprobante-pdfview.component';
import {EmisionCfeModule} from './pages/emision-cfe/emision-cfe.module';
import { SafeUrlPipePipe } from './directives/safe-url-pipe.pipe';
import {MatTooltipModule} from '@angular/material/tooltip';
import { DatosAnuladorComponent } from './popups/datos-anulador/datos-anulador.component';

@NgModule
({
  declarations:
  [
    AppComponent,
    DetalleCfeComponent,
    SuccessComponent,
    ErrorComponent,
    ProgressSpinnerComponent,
    ConfirmationComponent,
    VersionComponent,
    DetalleTipoCodigoComponent,
    ComprobantePDFViewComponent,
    SafeUrlPipePipe,
    DatosAnuladorComponent
  ],
  imports:
    [
      BrowserModule,
      AppRoutingModule,
      BrowserAnimationsModule,
      FormsModule,
      ReactiveFormsModule,
      MatButtonModule,
      MatToolbarModule,
      MatCardModule,
      MatListModule,
      MatCheckboxModule,
      MatSelectModule,
      MatDatepickerModule,
      MatFormFieldModule,
      MatMenuModule,
      MatSidenavModule,
      MatInputModule,
      MatNativeDateModule,
      MatRadioModule,
      MatExpansionModule,
      MatGridListModule,
      MatTableModule,
      MatDialogModule,
      MatIconModule,
      MatProgressSpinnerModule,
      HttpClientModule,
      KeycloakAngularModule,
      MainContainerModule,
      ErrorPageModule,
      PageNotFoundModule,
      SharedModule,
      MatSnackBarModule,
      MatAutocompleteModule,
      MatChipsModule,
      EmisionCfeModule,
      MatTooltipModule
    ],
  exports:
    [
      AppRoutingModule,
      MatDialogModule,
      DetalleCfeComponent,
      SuccessComponent,
      ErrorComponent,
      ConfirmationComponent,
      ComprobantePDFViewComponent,
      DatosAnuladorComponent
    ],
  providers:
  [
    EmisionCfeService,
    AuthenticationService,
    KeycloakService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializer,
      multi: true,
      deps: [KeycloakService]
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'es-ES'
    },
    NumberDirective,
    GlobalErrorHandlerService,
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandlerService
    },
    ErrorPageService,
    {provide: LocationStrategy, useClass: HashLocationStrategy }
  ],
  bootstrap: [AppComponent],
  entryComponents:
  [
    DetalleCfeComponent,
    SuccessComponent,
    ErrorComponent,
    ProgressSpinnerComponent,
    ConfirmationComponent,
    VersionComponent,
    ComprobantePDFViewComponent,
    DatosAnuladorComponent
  ]
})
export class AppModule
{

}
